/*
 * Basic live region utility.
 */
export default class LiveRegion {
  constructor(params = {}) {
    if (this.instance) {
      return this.instance;
    }
    
    const { container } = params;
    
    if (container instanceof HTMLElement) {
      this.region = container;
    } else if (typeof container === 'string') {
      this.region = document.querySelector(container);
    }
    
    this.instance = this;
  }

  instance: null
  
  /*
   * The text string to announce.
   */
  announce(message) {
    if (this.region && message) {
      this.region.textContent = message;
      this.clear();
    }
  }
  
  /*
   * Clear live region after announcement is made.
   */
  clear() {
    if (this.region) {
      setTimeout(() => this.region.textContent = '', 1000);
    }
  }
};



// WEBPACK FOOTER //
// in/scripts/live-region.js